type ThreeStageToggleProps = {
  value: string | null; // 'tv', 'mf', or 'th'
  onChange: (value: string | null) => void;
};

const ThreeStageToggle = ({ value, onChange }: ThreeStageToggleProps) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const width = rect.width;

    const section = Math.floor((clickX / width) * 3);

    if (section === 0) {
      onChange('TV');
    } else if (section === 1) {
      onChange('MF');
    } else {
      onChange('TH');
    }
  };

  const getPosition = () => {
    if (value === 'TV') return 'TV';
    if (value === 'TH') return 'TH';
    return 'MF';
  };

  return (
    <div className="three-stage-toggle-wrapper">
      <div className="three-stage-toggle" onClick={handleClick}>
        <div className={`three-stage-toggle-track ${getPosition()}`}>
          <span className="three-stage-toggle-label left">TV</span>
          <span className="three-stage-toggle-label center">MF</span>
          <span className="three-stage-toggle-label right">TH</span>
          <div className="three-stage-toggle-button" />
        </div>
      </div>
    </div>
  );
};

export default ThreeStageToggle;
